import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import { c as classNames } from '../../shared/bind-823d2b93.js';
import Icon from '../Icon/Icon.js';
import { onA11yKeyDown } from '../../utils/a11y/onA11yKeyDown.js';
import { KeyboardKey } from '../../constants/keyboard.js';
import { getTestId } from '../../utils/testId.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import * as React from 'react';
import { X as X12 } from '../../shared/X12-b7f8884b.js';

var _excluded = ["title", "titleId"];
var ChevronRight12 = function ChevronRight12(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 12 12",
    width: 12,
    height: 12,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M4.102 1.852a.563.563 0 0 0 0 .796L7.455 6 4.102 9.352a.562.562 0 1 0 .796.796l3.75-3.75a.563.563 0 0 0 0-.796l-3.75-3.75a.563.563 0 0 0-.796 0"
  }));
};
ChevronRight12.Size = 12;
ChevronRight12.Title = "ChevronRight";

var styles = {
  "unit-base": "4",
  "default": "web_ui__PromoBanner__default",
  "narrow": "web_ui__PromoBanner__narrow",
  "tight": "web_ui__PromoBanner__tight",
  "wide": "web_ui__PromoBanner__wide",
  "promo-banner": "web_ui__PromoBanner__promo-banner",
  "title": "web_ui__PromoBanner__title",
  "body": "web_ui__PromoBanner__body",
  "content": "web_ui__PromoBanner__content",
  "clickable": "web_ui__PromoBanner__clickable",
  "closable": "web_ui__PromoBanner__closable",
  "icon": "web_ui__PromoBanner__icon",
  "inner-content": "web_ui__PromoBanner__inner-content",
  "action": "web_ui__PromoBanner__action",
  "text": "web_ui__PromoBanner__text",
  "close-button": "web_ui__PromoBanner__close-button"
};

var Styling = /*#__PURE__*/function (Styling) {
  Styling["Default"] = "default";
  Styling["Narrow"] = "narrow";
  Styling["Tight"] = "tight";
  Styling["Wide"] = "wide";
  return Styling;
}(Styling || {});
var cssClasses = classNames.bind(styles);
var PromoBanner = function PromoBanner(props) {
  var _props$styling = props.styling,
    styling = _props$styling === void 0 ? Styling.Default : _props$styling,
    title = props.title,
    body = props.body,
    icon = props.icon,
    onClose = props.onClose,
    onClick = props.onClick,
    aria = props.aria,
    testId = props.testId,
    width = props.width,
    clickable = props.clickable,
    closable = props.closable;
  var closeButtonAriaLabel = closable ? props.closeButtonAriaLabel : undefined;
  var actionText = clickable ? props.actionText : undefined;
  var bannerClass = cssClasses('promo-banner', styling);
  var contentClass = cssClasses(styles.content, {
    clickable: clickable,
    closable: closable
  });
  var titleClass = cssClasses(styles.title, {
    'gutter-right': closable
  });
  var bodyClass = cssClasses(styles.body, {
    'gutter-right': closable
  });
  var customStyle = width ? {
    width: width
  } : undefined;
  var tabIndex = clickable ? 0 : undefined;
  var role = clickable ? 'link' : undefined;
  var handleKeyDown = function handleKeyDown(event) {
    onA11yKeyDown(event, {
      keys: [KeyboardKey.Space, KeyboardKey.Enter]
    });
  };
  var renderTitle = function renderTitle() {
    return /*#__PURE__*/jsx("h4", {
      className: titleClass,
      "data-testid": getTestId(testId, 'title'),
      children: title
    });
  };
  var renderBody = function renderBody() {
    return /*#__PURE__*/jsx("div", {
      className: bodyClass,
      "data-testid": getTestId(testId, 'body'),
      children: body
    });
  };
  var renderIcon = function renderIcon() {
    if (!icon) return null;
    return /*#__PURE__*/jsx("div", {
      className: styles.icon,
      "aria-hidden": true,
      "data-testid": getTestId(testId, 'icon'),
      children: icon
    });
  };
  var renderAction = function renderAction() {
    if (!actionText) return null;
    return /*#__PURE__*/jsxs("div", {
      className: styles.action,
      children: [/*#__PURE__*/jsx("div", {
        className: styles.text,
        "data-testid": getTestId(testId, 'action-text'),
        children: actionText
      }), /*#__PURE__*/jsx("div", {
        className: styles.icon,
        children: /*#__PURE__*/jsx(Icon, {
          display: Icon.Display.InlineBlock,
          testId: getTestId(testId, 'action-icon'),
          name: ChevronRight12
        })
      })]
    });
  };
  var renderCloseButton = function renderCloseButton() {
    if (!closable) return null;
    return /*#__PURE__*/jsx("div", {
      "aria-label": closeButtonAriaLabel,
      role: "button",
      tabIndex: 0,
      className: styles['close-button'],
      onClick: onClose,
      onKeyDown: handleKeyDown,
      "data-testid": getTestId(testId, 'close-button'),
      children: /*#__PURE__*/jsx(Icon, {
        display: Icon.Display.Block,
        name: X12,
        aria: {
          'aria-hidden': true
        }
      })
    });
  };
  return /*#__PURE__*/jsxs("div", {
    className: bannerClass,
    "data-testid": testId,
    children: [/*#__PURE__*/jsxs("div", _objectSpread(_objectSpread({
      className: contentClass,
      style: customStyle,
      "data-testid": getTestId(testId, 'content'),
      tabIndex: tabIndex,
      role: role,
      onClick: onClick,
      onKeyDown: clickable ? handleKeyDown : undefined
    }, aria), {}, {
      children: [renderIcon(), /*#__PURE__*/jsxs("div", {
        className: styles['inner-content'],
        children: [renderTitle(), renderBody(), renderAction()]
      })]
    })), renderCloseButton()]
  });
};
PromoBanner.Styling = Styling;

export { PromoBanner as default };
//# sourceMappingURL=PromoBanner.js.map
